import classNames from "classnames";
import React from "react";

import styles from "../FormField.module.scss";
import InputMask from "react-input-mask";

export interface IMaskFormField {
  id?: string;
  error?: string;
  name?: string;
  mask?: string | (string | RegExp)[];
  maskPlaceholder?: string;
  readOnly?: boolean;
  registerField?: any;
  isFocused?: boolean;
  isRequired?: boolean;
  autoComplete?: string;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

export const MaskFormField: React.FC<IMaskFormField> = ({
  id,
  error,
  name,
  readOnly = false,
  registerField,
  isFocused,
  mask = "",
  maskPlaceholder = "_",
  autoComplete,
}) => {
  return (
    <InputMask
      {...registerField}
      id={id}
      className={classNames(styles.input, {
        [styles.error]: error,
        [styles.active]: isFocused,
      })}
      mask={mask}
      maskPlaceholder={maskPlaceholder}
      name={name}
      type="text"
      readOnly={readOnly}
      autoComplete={autoComplete}
    />
  );
};
